import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as firebase from "firebase/app";

export default {
  name: "AddTagsDialog",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isEdit: false,
      tagsToAdd: [],
      tagToEdit: {
        id: null,
        name: null,
      }
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    allTags() {
      return this.$store.state.tagsModule.tags
    }
  },
  methods: {
    open(tagToEdit) {
      if (tagToEdit) {
        this.isEdit = true
        this.tagCopy = { ...tagToEdit }
        this.tagToEdit = { ...tagToEdit }
      }
      this.dialog = true;
    },
    async addTags() {

      //added setTimeout to execute selectTag() before this function when user type second tag and not press enter but press save to call this function
      setTimeout(async () => {

        const form = this.$refs.addTagsForm as any;

        if (!form.validate() || this.tagsToAdd?.length <= 0) return;

        this.loading = true

        const result = await this.$store.dispatch('addTags', { tagsNames: [...this.tagsToAdd], entity: 'all' })

        if (result.isSuccess === true) {
          this.close()
          return
        }
        else if (result.existedTags?.length > 0) {
          this.$refs.observer.setErrors({ Name: [`${result.existedTags.join(', ')} ${this.$t(`GeneralTranslations.Name${result.existedTags.length > 1 ? 's' : ''}AlreadyExists`)}`] });
        }
        else {
          this.$toast.open({ message: this.$t('GeneralTranslations.UnhandledError'), type: 'error' })
        }
        this.loading = false
      }, 100)
    },

    async editTag() {

      const form = this.$refs.addTagsForm as any;

      if (!form.validate()) return;

      if (this.isEdit && this.tagCopy.name == this.tagToEdit.name) {
        this.close()
        return
      }

      this.loading = true

      const result = await this.$store.dispatch('updateTag', { id: this.tagToEdit.id, name: this.tagToEdit.name })

      if (result.isExistByName === true) {
        this.$refs.observer.setErrors({ Name: [this.$t('GeneralTranslations.NameAlreadyExists')] });
        this.loading = false
        return
      }
      else {
        this.close()
      }
    },

    selectTag(selectedTags) {
      this.tagsToAdd = selectedTags.map((tag) => tag.trim().toLowerCase())
    },
    
    removeTag(tagName) {
      this.tagsToAdd = this.tagsToAdd.filter(x => x !== tagName);
    },

    async isExistsByName(name, skipId) {
      let query = firebase.firestore().collection("tags").where("facilityId", "==", this.facility.id).where("name", "==", name)

      if (skipId) {
        query = query.where(firebase.firestore.FieldPath.documentId(), '!=', skipId)
      }

      const docs = await query.get()

      return docs.size > 0
    },

    close() {
      this.dialog = false
      this.isEdit = false
      this.loading = false
      this.tagToEdit.id = null
      this.tagToEdit.name = null
      this.tagsToAdd = []
    }
  }
}